import { render, staticRenderFns } from "./HouseComponentCatalogueImport.vue?vue&type=template&id=3294ed37&"
import script from "./HouseComponentCatalogueImport.vue?vue&type=script&lang=js&"
export * from "./HouseComponentCatalogueImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports